exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog[data-v-4aadd3e7]{overflow-y:initial!important}.modal-body[data-v-4aadd3e7]{overflow-y:auto}.modalRoll[data-v-4aadd3e7]{height:80vh}.pointer-click[data-v-4aadd3e7]{cursor:pointer}", ""]);

// exports
